module.exports = __webpack_public_path__ + "static/media/appbar-icon.af24860c.png";